import styled from 'styled-components';

export const CardContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  cursor: pointer;
  padding: 10px 10px;
  user-select: none;
  background: ${({ $isDragging, $isSelected }) =>
    $isDragging ? '#f0f8ff' : $isSelected ? '#fffbf0' : '#fff'};
  border-left: 4px solid ${({ $statusColor }) => $statusColor || 'transparent'};
`;

export const CompanyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CardCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #2d6cdf;
  flex-shrink: 0;
`;

export const RightCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #2d6cdf;
  flex-shrink: 0;
`;

export const CardContent = styled.div`
  padding: 0;
`;

export const CompanyName = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #1d3557;
  margin: 0 0 12px 0;
`;

export const PriorityTag = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${({ $priority }) => {
    switch ($priority?.toLowerCase()) {
      case 'high':
        return '#fee2e2';
      case 'medium':
        return '#fef3c7';
      case 'low':
        return '#dbeafe';
      case 'new':
        return '#e0e7ff';
      default:
        return '#f3f4f6';
    }
  }};
  color: ${({ $priority }) => {
    switch ($priority?.toLowerCase()) {
      case 'high':
        return '#dc2626';
      case 'medium':
        return '#f59e0b';
      case 'low':
        return '#3b82f6';
      case 'new':
        return '#6366f1';
      default:
        return '#6b7280';
    }
  }};
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const InfoText = styled.span`
  font-size: 12px;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5;
`;
export const CompanyText = styled.div`
  font-family: Nunito;
  font-weight: 700;
  font-style: Bold;
  font-size: 9px;
  leading-trim: NONE;
  line-height: 13.5px;
  letter-spacing: 0.45px;
  text-transform: uppercase;
  color: #90a1b9;
`;
